var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirl2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M470.022,342.021c0.688-47.484-15.14-55.742-23.054-83.613c-7.967-28.059,0.139-47.219-9.29-78.279  c-8.774-28.903-24.714-33.786-29.591-74.839C399.828,35.784,324.817,0,287.656,0c-10.508,0-17.683,2.667-22.507,5.857  c-5.583,3.694-12.716,3.694-18.298,0C242.027,2.667,234.852,0,224.344,0c-37.161,0-112.172,35.784-120.43,105.29  c-4.878,41.052-20.817,45.935-29.591,74.839c-9.429,31.06-1.323,50.22-9.29,78.279c-7.914,27.871-23.742,36.129-23.054,83.613  c0.798,55.066-30.968,67.441-18.581,103.914c9.245,27.22,59.183,49.548,59.183,49.548H429.42c0,0,49.938-22.329,59.183-49.548  C500.989,409.462,469.223,397.087,470.022,342.021z",
    fill: "#363234",
    "data-original": "#64505a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M256,8.627c-3.179,0-6.358-0.923-9.149-2.77C242.027,2.667,234.852,0,224.344,0  c-37.161,0-112.172,35.784-120.43,105.29c-4.878,41.052-20.817,45.935-29.591,74.839c-9.429,31.06-1.323,50.22-9.29,78.279  c-7.914,27.871-23.742,36.129-23.054,83.613c0.798,55.066-30.968,67.441-18.581,103.914c9.245,27.22,59.183,49.548,59.183,49.548  H256V8.627z",
    fill: "#2e2a2c",
    "data-original": "#5a4650",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M412.878,401.236l-85.291-30.103c-13.207-4.661-22.039-17.144-22.039-31.149V297.29h-99.097v42.694  c0,14.005-8.832,26.488-22.039,31.149l-85.291,30.103c-19.81,6.992-33.057,25.716-33.057,46.723v39.267  c0,13.682,11.092,24.774,24.774,24.774h330.323c13.682,0,24.774-11.092,24.774-24.774v-39.267  C445.935,426.952,432.688,408.228,412.878,401.236z",
    fill: "#b67f5f",
    "data-original": "#b67f5f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M412.878,401.236l-56.91-20.087c-22.397,30.957-52.879,65.096-88.361,84.013  c-7.238,3.859-15.976,3.859-23.214,0c-35.482-18.916-65.964-53.056-88.361-84.013l-56.91,20.087  c-19.81,6.992-33.057,25.716-33.057,46.724v39.266c0,13.682,11.092,24.774,24.774,24.774h330.323  c13.682,0,24.774-11.092,24.774-24.774V447.96C445.935,426.952,432.688,408.228,412.878,401.236z",
    fill: "#7b62cf",
    "data-original": "#b4e6a0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M206.452,319.756c15.247,6.742,32.001,10.567,49.548,10.567s34.301-3.824,49.548-10.567V297.29  h-99.097L206.452,319.756L206.452,319.756z",
    fill: "#594d46",
    "data-original": "#a06e50",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M256,313.806L256,313.806c-59.291,0-107.355-48.064-107.355-107.355V66.065h214.71v140.387  C363.355,265.742,315.29,313.806,256,313.806z",
    fill: "#cd916e",
    "data-original": "#cd916e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M148.645,66.065v140.387c0,59.29,48.065,107.355,107.355,107.355c5.632,0,11.118-0.565,16.516-1.399  c-51.428-7.964-90.839-52.296-90.839-105.956v-42.946c0-6.79,2.106-13.35,5.702-19.11c0.019-0.03,0.038-0.061,0.057-0.091  c13.559-21.759,26.252-24.958,40.947-28.66c8.44-2.127,18.273-4.605,27.616-10.831c9.344,6.226,19.177,8.704,27.616,10.831  c14.696,3.703,27.388,6.901,40.947,28.659c12.614,20.24,26.729,31.428,38.791,40.071V66.065H148.645z",
    fill: "#b67f5f",
    "data-original": "#b67f5f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M256,264.258c-12.395,0-23.823-3.976-30.573-10.637c-3.25-3.21-3.282-8.435-0.081-11.677  c3.218-3.25,8.444-3.282,11.677-0.081c2.75,2.71,9.363,5.879,18.976,5.879c9.613,0,16.226-3.169,18.976-5.879  c3.234-3.202,8.46-3.169,11.677,0.081c3.202,3.242,3.169,8.468-0.081,11.677C279.823,260.282,268.395,264.258,256,264.258z",
    fill: "#594d46",
    "data-original": "#a06e50",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M206.452,206.452c-4.565,0-8.258-3.694-8.258-8.258v-8.258c0-4.565,3.694-8.258,8.258-8.258   s8.258,3.694,8.258,8.258v8.258C214.71,202.758,211.016,206.452,206.452,206.452z",
    fill: "#2e2a2c",
    "data-original": "#5a4650",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M305.548,206.452c-4.565,0-8.258-3.694-8.258-8.258v-8.258c0-4.565,3.694-8.258,8.258-8.258   c4.565,0,8.258,3.694,8.258,8.258v8.258C313.806,202.758,310.113,206.452,305.548,206.452z",
    fill: "#2e2a2c",
    "data-original": "#5a4650",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M214.71,173.419h-16.516c-4.565,0-8.258-3.694-8.258-8.258s3.694-8.258,8.258-8.258h16.516   c4.565,0,8.258,3.694,8.258,8.258S219.274,173.419,214.71,173.419z",
    fill: "#2e2a2c",
    "data-original": "#5a4650",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M313.806,173.419H297.29c-4.565,0-8.258-3.694-8.258-8.258s3.694-8.258,8.258-8.258h16.516   c4.565,0,8.258,3.694,8.258,8.258S318.371,173.419,313.806,173.419z",
    fill: "#2e2a2c",
    "data-original": "#5a4650",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M126.532,446.218L84.38,409.617c-4.319,3.52-7.948,7.738-10.847,12.446l42.176,36.623   c5.419,4.71,8.532,11.532,8.532,18.71V512h16.516v-34.605C140.758,465.427,135.573,454.065,126.532,446.218z",
    fill: "#ad9ad7",
    "data-original": "#9bdc9b",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M385.839,446.218l42.152-36.601c4.319,3.52,7.948,7.738,10.847,12.446l-42.176,36.623   c-5.419,4.71-8.532,11.532-8.532,18.71V512h-16.516v-34.605C371.613,465.427,376.798,454.065,385.839,446.218z",
    fill: "#ad9ad7",
    "data-original": "#9bdc9b",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M446.968,258.408c-7.967-28.059,0.139-47.219-9.29-78.279c-8.774-28.903-24.714-33.786-29.591-74.839  C399.828,35.784,324.817,0,287.656,0c-10.508,0-17.683,2.667-22.507,5.857c-2.791,1.847-5.97,2.77-9.149,2.77v73.954  c21.333,26.839,52.989,5.505,82.581,52.989c25.152,40.36,56.735,39.34,67.845,71.16c3.184,9.12,1.457,18.864,2.219,28.494  c4.258,53.808,45.548,78.583,64.109,134.735c-1.77-8.019-2.889-17.138-2.732-27.938C470.71,294.537,454.882,286.279,446.968,258.408  z",
    fill: "#322d2f",
    "data-original": "#6e5a64",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M65.032,258.408c7.967-28.059-0.139-47.219,9.29-78.279c8.774-28.903,24.714-33.786,29.591-74.839  C112.172,35.784,187.183,0,224.344,0c10.508,0,17.683,2.667,22.507,5.857c2.791,1.847,5.97,2.77,9.149,2.77v73.954  c-21.333,26.839-52.989,5.505-82.581,52.989c-25.152,40.36-56.735,39.34-67.845,71.16c-3.184,9.12-1.457,18.864-2.219,28.494  c-4.258,53.808-45.548,78.583-64.109,134.735c1.77-8.019,2.889-17.138,2.732-27.938C41.29,294.537,57.118,286.279,65.032,258.408z",
    fill: "#363234",
    "data-original": "#64505a",
    className: ""
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl2);
export default __webpack_public_path__ + "static/media/girl2.c82ff1315ffc143c9da62f3f794f501a.svg";
export { ForwardRef as ReactComponent };